import { Fragment } from 'react';

import { Box } from '../../../components/Box/Box';
import BodyRow from '../Row/BodyRow';

function Body({
  ref,
  activeRowId,
  rows,
  prepareRow,
  isBordered = true,
  columnCount,
  paddingBottom = 0,
  paddingTop = 0,
  virtualRows,
}) {
  const shouldVirtualize = Array.isArray(virtualRows) && virtualRows.length > 0;
  const resolvedColumnCount = columnCount || rows[0]?.cells?.length || 1;
  const resolvedRows = shouldVirtualize
    ? virtualRows.map((virtualRow) => rows[virtualRow.index]).filter(Boolean)
    : rows;

  return (
    <Box as="tbody" bg="inherit" ref={ref}>
      {shouldVirtualize && paddingTop > 0 && (
        <tr aria-hidden="true">
          <td
            colSpan={resolvedColumnCount}
            style={{ height: paddingTop, padding: 0, border: 0 }}
          />
        </tr>
      )}
      {resolvedRows.map((row) => {
        prepareRow(row);
        const { cells, disabled, id, isSelected, onShowDetails } = row;
        return (
          <BodyRow
            key={id}
            activeRowId={activeRowId}
            data={row.original}
            disabled={disabled}
            isSelected={isSelected}
            isBordered={isBordered}
            onClick={onShowDetails}
            rowIndex={row.index}
          >
            {cells.map((cell) => (
              <Fragment key={cell.column.key}>{cell.render('Cell')}</Fragment>
            ))}
          </BodyRow>
        );
      })}
      {shouldVirtualize && paddingBottom > 0 && (
        <tr aria-hidden="true">
          <td
            colSpan={resolvedColumnCount}
            style={{ height: paddingBottom, padding: 0, border: 0 }}
          />
        </tr>
      )}
    </Box>
  );
}

export default Body;
